const maintenanceRequiredTypes = [
    {
        "name": "Yes",
        "code": "YES"
    },
    {
        "name": "No",
        "code": "NO"
    },
    {
        "name": "Cosmetic",
        "code": "COSMETIC"
    }
]

export default maintenanceRequiredTypes;